import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { completeSsoFlow } from "@/lib/auth";
import { useAuth } from "@/hooks/use-auth";
import { Skeleton } from "@/components/ui/skeleton";

export function AuthCallbackPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const code = params.get("code");
    if (!code) {
      setError("Missing authorization code");
      return;
    }
    completeSsoFlow(code)
      .then(async () => {
        await refresh();
        navigate("/", { replace: true });
      })
      .catch((err: Error) => setError(err.message));
  }, [params, navigate, refresh]);

  return (
    <div className="min-h-screen grid place-items-center bg-bg px-6">
      <div className="w-full max-w-sm text-center">
        {error ? (
          <>
            <h1 className="text-xl font-semibold text-ink">Sign in failed</h1>
            <p className="mt-2 text-sm text-danger">{error}</p>
            <button
              onClick={() => navigate("/sign-in", { replace: true })}
              className="mt-5 text-sm text-accent underline-offset-4 hover:underline"
            >
              Try again
            </button>
          </>
        ) : (
          <div className="space-y-3">
            <Skeleton className="mx-auto h-5 w-32" />
            <Skeleton className="mx-auto h-3 w-48" />
            <p className="pt-3 text-xs text-ink-faint">Completing sign in...</p>
          </div>
        )}
      </div>
    </div>
  );
}
